module.exports = __webpack_public_path__ + "media/common-loon-3.10897820.mp3";